import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Homepage, HomepageProps } from './Homepage';
import { PersonalisedBanner } from '../components/PersonalisedBanner';

export const LoggedInHomepage = (props: Omit<HomepageProps, 'isLoggedIn'>) => {
    const router = useRouter();

    useEffect(() => {
        if (typeof window === undefined) {
            return;
        }

        let isDismounting = false;

        if (
            !isDismounting &&
            window.location.pathname.includes('index-logged-in')
        ) {
            router.replace('/');
        }

        return () => {
            isDismounting = true;
        };
    }, [router]);

    return (
        <Homepage
            personalisedBanner={<PersonalisedBanner />}
            isLoggedIn
            {...props}
        />
    );
};
